"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _reorder = _interopRequireDefault(require("../../../../../../helpers/reorder.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var FilterTags = function FilterTags(props) {
  var filterGroup = props.filterGroup,
    allTags = props.allTags;
  var tags = filterGroup.tags;
  var onDragEnd = function onDragEnd(result) {
    var destination = result.destination,
      source = result.source;
    if (!destination) {
      return;
    }
    (0, _reorder["default"])(tags, source.index, destination.index);
  };
  var handleAddTag = function handleAddTag(values) {
    if (values.tag) {
      tags.addField(values.tag);
    }
  };
  var getItemStyle = function getItemStyle(isDragging) {
    return {
      userSelect: 'none',
      background: isDragging ? '#f0f0f0' : ''
    };
  };
  var existingTags = tags.map(function (tag) {
    return tag.value;
  });
  var tagOptions = allTags.filter(function (tag) {
    return !existingTags.includes(tag.name);
  }).map(function (tag) {
    return {
      value: tag.name,
      label: tag.label === tag.name ? tag.label : "".concat(tag.label, " (").concat(tag.name, ")")
    };
  });
  tagOptions.unshift({
    value: '',
    label: '-- Choose Tag --'
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Filter Tags must be defined in Tags before they can be added here."
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Filter Tags"), /*#__PURE__*/_react["default"].createElement(_question["default"], {
    spaceLeft: true
  })))), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: props.filterGroup.id.value + 'droppable'
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: _style["default"].filterTagsGroup
    }, provided.droppableProps, {
      ref: provided.innerRef
    }), props.filterGroup.tags.map(function (filterTag, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: filterTag.value,
        index: index,
        key: filterTag.value
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: "row ".concat(_style["default"].filterTag),
          key: filterTag.value,
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: _style["default"].dragHandle
        }, dragProvided.dragHandleProps, {
          style: getItemStyle(dragSnapshot.isDragging, dragProvided.draggableProps.style)
        }), /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            flexGrow: '1',
            padding: '0.5em'
          }
        }, filterTag.value), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            padding: '0.5em'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
          className: "btn btn-danger btn-xs",
          onClick: function onClick() {
            tags.removeField(index);
          }
        })));
      });
    }), provided.placeholder, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      onSubmit: handleAddTag,
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "tag",
          component: _cccisdFormik.CccisdSelect,
          label: "Add Tag",
          options: tagOptions
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary",
          type: "submit"
        }, "Add Tag"))));
      }
    }));
  })));
};
var _default = exports["default"] = FilterTags;